import { Popover, Transition } from "@headlessui/react";

function PopOverTransition(props) {
    const { children, open } = props;
    return (
        <Popover>
            <>
                <Transition
                    show={open}
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                >
                    <Popover.Panel>
                        {children}
                    </Popover.Panel>
                </Transition>
            </>
        </Popover>
    );
}

export default PopOverTransition;